import React, {memo} from 'react';
import {Alert, Button, Form, Modal, Spinner} from "react-bootstrap";
import {createDocument} from "../../../api/Document";

function DocumentCreator() {
    const [modalShow, setModalShow] = React.useState(false)

    return (
        <>
            <Button variant="secondary" onClick={() => setModalShow(true)}>Créer un nouveau document</Button>

            <FormularModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    )
}

function FormularModal(props) {
    const [filename, setFilename] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [document, setDocument] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(null)

    async function handleSubmit() {
        const formData = new FormData();

        formData.append('filename', filename)
        formData.append('description', description)
        formData.append('document', document)

        const documents = {
            filename: filename,
            description: description
        }

        setLoading(true)

        const documentCreated = await createDocument(documents, document)

        if (documentCreated === 201) {
            setLoading(false)
            window.location.reload()
        } else if (documentCreated === 422) {
            setError('Il n\'y a pas de fichier')
            setLoading(false)
        } else if (documentCreated === 415) {
            setError('Le fichier n\'est pas un PDF')
            setLoading(false)
        } else if (documentCreated === 401) {
            setError('Il y a eut un problème lors de l\'ajout du document')
            setLoading(false)
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Création d'un événement
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formBasicLastname">
                        <Form.Label>Titre du document</Form.Label>
                        <Form.Control type="text" placeholder="Entrer le titre du document" value={filename} onChange={e => setFilename(e.target.value)} />
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {filename.length} / 100
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="formBasicFirstname">
                        <Form.Label>Description du document</Form.Label>
                        <Form.Control type="text" placeholder="Entrer la description du document" value={description} onChange={e => setDescription(e.target.value)} />
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {description.length} / 200
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="formPicture">
                        <Form.Label>Document</Form.Label>
                        <Form.File id="formcheck-api-custom" custom>
                            <Form.File.Input onChange={e => setDocument(e.target.files[0])} />
                            <Form.File.Label data-browse="Ajouter">
                                {document !== "" ? document.name : "Document"}
                            </Form.File.Label>
                        </Form.File>
                    </Form.Group>

                    {error !== null ? (
                        <Alert variant='danger'>
                            {error}
                        </Alert>
                    ) : null}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Close</Button>
                {loading ? (
                    <Spinner animation="grow" variant="primary" />
                ) : (
                    <Button variant="primary" onClick={handleSubmit}>Ajouter</Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default DocumentCreator;
